<template>
  <div class="main-wrap" ref="main">
    <el-tabs
      class="main-tabs"
      v-model="currentHeadTab"
      type="card"
      closable
      :before-leave="beforeLeave"
    >
      <el-tab-pane
        v-for="(item, index) in headTabs"
        :key="item.title"
        :label="item.title"
        :name="item.addNum"
      >
        <!-- <component :is="item.content"></component> -->
        <transition name="list">
          <component :is="item.content"></component>
        </transition>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="less">
  .main-wrap {
    box-sizing: border-box;
    height: 100%;
    .main-tabs,
    .main-tabs .el-tab-pane {
      box-sizing: border-box;
      height: 100%;
    }
    .el-tabs--card > .el-tabs__header {
      display: none;
    }
  }
  // 动画
  .list-enter-active {
    transition: all 0.5s;
  }
  .list-enter
      /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(10px);
  }
  // 保存按钮
  .common-save-btn {
    background-color: #fff;
    width: calc(100vw - 340px);
    height: 70px;
    top: calc(100vh - 70px);
    left: 320px;
    box-shadow: 0px -4px 10px 0px rgba(43, 63, 87, 0.1);
    padding: 14px 0;
    z-index: 10;
    .el-button {
      width: 130px;
      height: 42px;
      margin: 0 20px;
      &:first-of-type {
        background-color: @SAASCOLOR;
      }
    }
  }
  // 按钮主题样式
  div .el-button--default.el-button:hover {
    color: inherit;
    background: inherit;
    border: 1px solid #dcdfe6;
  }
</style>

<script>
  import index from "@/views/index.vue";
  // import { mapActions, mapGetters } from "vuex";
  export default {
    props: ["indexTabs", "indexTabsValue", "tabIndex"],
    data() {
      return {};
    },
    created() {
      // console.log(JSON.parse(sessionStorage.getItem("headTabs")));
      // console.log(JSON.parse(sessionStorage.getItem("currentHeadTab")));
      // console.log(this.headTabs);
      // this.headTabs.forEach(function(item, index) {
      //   item.content = () => import(`../views/${item.url}.vue`);
      // });
    },
    computed: {
      // ...mapGetters(["headTabs", "currentHeadTab"])
      headTabs: {
        get: function () {
          // console.log('state',this.$store.state.headTabs)
          // if (JSON.parse(sessionStorage.getItem("currentHeadTab")) != 1) {
          //   return JSON.parse(sessionStorage.getItem("headTabs"));
          // } else {
          this.hidelscroll();
          return this.$store.state.headTabs;
          // }
        },
        set: function (newVal) {
          // console.log('newVal',newVal)
          this.$store.state.headTabs = newVal;
        },
      },
      currentHeadTab: {
        get: function () {
          // console.log('currentTab',this.$store.state.currentHeadTab)
          // if (JSON.parse(sessionStorage.getItem("currentHeadTab")) != 1) {
          //   return JSON.parse(sessionStorage.getItem("currentHeadTab"));
          // } else {
          // console.log('currentTab',this.$store.state.currentTab)
          // 总数、需刷新的索引、当前索引、点击后的索引、剪发操作
          return this.$store.state.currentHeadTab;
          // }
        },
        set: function (newVal) {
          // console.log('currentval',newVal)
          this.$store.state.headTabsValue = newVal;
        },
      },
    },
    methods: {
      beforeLeave(activeName, oldActiveName) {
        this.$refs.main.parentNode.parentNode.style.overflowY = "scroll";
        this.$refs.main.parentNode.parentNode.parentNode.style.paddingRight = "0";
        this.$refs.main.parentNode.parentNode.parentNode.parentNode.style.paddingBottom =
          "0";
      },
      // 判断页面隐藏滚轮
      hidelscroll() {
        let title = this.$store.getters.getCurrentTab.title,
          url = this.$store.getters.getCurrentTab.url,
          needHide =
            title == "发布活动" ||
            url == "activity" ||
            title == "添加员工" ||
            url == "staff-add" ||
            title == "编辑员工" ||
            url == "staff-edit" ||
            title == "基础信息" ||
            url == "seller-baseinfo";
        if (needHide) {
          this.$emit("hidelscroll", true);
        } else {
          this.$emit("hidelscroll", false);
        }
      },
    },
    components: {
      index,
    },
  };
</script>



// WEBPACK FOOTER //
// src/views/main.vue